import React, { useState, useEffect } from "react"

import * as styles from "~/styles/pdp/pdp.module.scss"



const CxChat = ({ title }) => {
  const [showing, setShowing] = useState(false)

  const handleClick = () => {
    window.Gladly.startConversation([
      { type: 'TEXT', text: `Hi, would you be able to help me with information about the ${title}?` }
    ]);
  }

  const checkAvail = () => {
    if (typeof window.Gladly === 'undefined') {
      setTimeout(() => {
        checkAvail()
      }, 2000)
      return
    }

    if (sessionStorage.getItem('cxchat')) {
      setShowing(true)
      return
    }

    const availstates = ['AVAILABLE','UNAVAILABLE_BUSY']

    setShowing( availstates.includes(window.Gladly.getAvailability()) )

    if (window.Gladly){
      window.Gladly.on("availability:change", (availability) => { 
        setShowing(availstates.includes(availability))
      })
    }
  }

  useEffect(() => {
    setTimeout(() => {
      checkAvail()
    }, 1000)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!showing) return (<></>)
  return (
    <div className={styles.cxchatwr}>
      <button
        type={'button'}
        className={styles.cxchat_btn}
        onClick={(e)=> handleClick()}
      >
        Chat With a Stylist
      </button>
    </div> 
  )
};

export default CxChat




